import { TCP, GYM } from './brands.constants';

const COMMON_STYLE_FOR_HEADER = {
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#1a1a1a',
  fontFamily: 'Montserrat',
  fontSize: '20px',
  fontWeight: '500',
  margin: '0 0 5px',
};

const COMMON_STYLE_FOR_SUB_HEADER = {
  ...COMMON_STYLE_FOR_HEADER,
  margin: '5px 0 0',
  fontWeight: 'normal',
  fontSize: '16px',
};

const HEADER_STYLES = {
  [TCP]: {
    PLP: {
      ...COMMON_STYLE_FOR_HEADER,
      margin: '0 0 6px',
      fontFamily: 'Nunito',
      fontSize: '36px',
      fontWeight: 'bold',
    },
    PLP_MOBILE: {
      ...COMMON_STYLE_FOR_HEADER,
      fontFamily: 'Nunito',
      fontWeight: 'bold',
    },
  },
  [GYM]: {
    PLP: {
      ...COMMON_STYLE_FOR_HEADER,
      margin: '0 0 10px',
      fontSize: '36px',
    },
    PLP_MOBILE: {
      ...COMMON_STYLE_FOR_HEADER,
    },
  },
};

const SUB_HEADER_STYLES = {
  [TCP]: {
    PLP: {
      ...COMMON_STYLE_FOR_SUB_HEADER,
      margin: '6px 0 0',
      fontFamily: 'Nunito',
      fontSize: '26px',
    },
    PLP_MOBILE: {
      ...COMMON_STYLE_FOR_SUB_HEADER,
      fontFamily: 'Nunito',
      lineHeight: '1.25',
    },
  },
  [GYM]: {
    PLP: {
      ...COMMON_STYLE_FOR_SUB_HEADER,
      margin: '10px 0 0',
      fontSize: '26px',
    },
    PLP_MOBILE: {
      ...COMMON_STYLE_FOR_SUB_HEADER,
      lineHeight: '1.25',
    },
  },
};

export { HEADER_STYLES, SUB_HEADER_STYLES };
